
export const ActionButtonGroup = ({ children }) => {
    
    return (
        <div className="row g-1 px-2">
            {children}
        </div>
    )
}
